"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewButtonWrapper = exports.Title = exports.Root = exports.ImageWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('a', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  widthValues
}) => ({
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  maxWidth: widthValues.mobile,
  textAlign: 'center',
  textDecoration: 'none',
  '&:hover': {
    button: {
      visibility: 'visible'
    },
    img: {
      WebkitFilter: 'brightness(80%)'
    }
  },
  [theme.breakpoints.up('sm')]: {
    maxWidth: widthValues.desktop
  }
}));
const ImageWrapper = exports.ImageWrapper = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  heightValues,
  theme,
  widthValues
}) => ({
  borderRadius: theme.spacing(2),
  display: 'block',
  height: heightValues.mobile,
  maxWidth: widthValues.mobile,
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  img: {
    height: '100%',
    left: 0,
    objectFit: 'cover',
    objectPosition: '50% 50%',
    position: 'absolute',
    top: 0,
    transition: '-webkit-filter 0.5s',
    width: '100%'
  },
  [theme.breakpoints.up('sm')]: {
    height: heightValues.desktop,
    maxWidth: widthValues.desktop
  }
}));
const ViewButtonWrapper = exports.ViewButtonWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  bottom: theme.spacing(3),
  position: 'absolute',
  textAlign: 'center',
  visibility: 'hidden',
  width: '100%'
}));
const Title = exports.Title = (0, _mui.styled)(_mui.Typography)(() => ({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  overflow: 'hidden'
}));
